import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Rate } from '../models/rate.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

const BASE_URL = environment.base_url;

@Injectable({
    providedIn: 'root'
})
export class PricingService {

    constructor(
        private http: HttpClient
    ) { }

    getRates(): Observable<Rate[]> {
        const token = localStorage.getItem('token') || '';
        var headers = {
            'X-Amz-Security-Token': token
        }


        return this.http.get(`${BASE_URL}/rates`, { headers })
            .pipe(
                retry(2),
                map((resp: { pricing: Rate[] }) => resp.pricing)
            )
    }
}
